import React, { Component } from 'react';

class Loading extends Component {

  render() {
    return (
      <div className="loading">
        <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
        <p className="loading-text">{this.props.text}</p>
      </div>
    );
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.js